import { Link } from "react-router-dom";
import type { StaffShiftSummary } from "../../../api/staffApi";
import { formatHourlyRate, formatShiftRange } from "../staffFormat";
import { ShiftStatusBadge } from "./ShiftStatusBadge";

type ShiftCardProps = {
  shift: StaffShiftSummary;
  to?: string;
  trailing?: React.ReactNode;
};

export function ShiftCard({ shift, to, trailing }: ShiftCardProps) {
  const content = (
    <>
      <div className="staff-shift-card__head">
        <span className="staff-shift-card__role">{shift.roleName}</span>
        <ShiftStatusBadge shift={shift} />
      </div>
      <p className="staff-shift-card__event">{shift.eventName}</p>
      <p className="staff-shift-card__time">{formatShiftRange(shift.scheduledStart, shift.scheduledEnd, shift.timezone)}</p>
      {shift.startingLocation ? <p className="staff-shift-card__location muted">{shift.startingLocation}</p> : null}
      <p className="staff-shift-card__rate muted">{formatHourlyRate(shift.hourlyRate)}</p>
      {trailing}
    </>
  );

  if (to) {
    return (
      <Link to={to} className="staff-shift-card staff-shift-card--link">
        {content}
      </Link>
    );
  }

  return <article className="staff-shift-card">{content}</article>;
}
